<template>
  <v-app id="login-pwd-ui">
    <v-content login>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6>
            <!--<v-toolbar v-if="status == 'newUser'" class="primary">
                <v-toolbar-title>Bem-Vindo!</v-toolbar-title>
            </v-toolbar>

            <v-toolbar v-else-if="status == 'existingUser'" class="primary">
                <v-toolbar-title>Bem-Vindo de Volta!</v-toolbar-title>
            </v-toolbar>-->

            <v-flex xs12>
              <div class="text-xs-center">
                <v-img fill-height v-if="this.img_folder"
                       :src="require('@/assets/clients/'+img_folder+'/logo.png')"
                       class="my-5 login-logo"
                       contain
                       height="120"
                ></v-img>
              </div>
            </v-flex>

            <div class="password-title1">
              <v-spacer class="my-2 password-title1-spacer"></v-spacer>

              <v-flex xs12>
                <h2>{{ $vuetify.t('$vuetify.authentication.login_step_password_title') }}</h2>
              </v-flex>
            </div>

            <div class="password-title2">
              <v-spacer class="my-2 password-title2-spacer"></v-spacer>

              <v-flex v-if="status == 'newUser'" xs12>
                <h4>{{ $vuetify.t('$vuetify.authentication.login_step_newuser_password_subtitle') }}</h4>
              </v-flex>
            </div>

            <v-spacer class="my-2 password-user-spacer"></v-spacer>

            <!-- Event Handling - Event Modifiers
            It is a very common need to call event.preventDefault(),
            therefore Vue provides event modifiers for v-on. Recall that modifiers are directive postfixes denoted by a dot. -->
            <v-form v-on:submit.prevent="submit" ref="form" v-model="valid" lazy-validation>
              <v-text-field
                  class="password"
                  prepend-icon="fal fa-key"
                  :append-icon="e1 ? 'fal fa-eye' : 'fal fa-eye-slash'"
                  @click:append="() => (e1 = !e1)"
                  name="password"
                  v-bind:label="$vuetify.t('$vuetify.authentication.password')"
                  v-model="password"
                  :type="e1 ? 'password' : 'text'"
                  :rules="passwordRules"
                  required
                  :counter=false
              ></v-text-field>

              <v-spacer class="my-2"></v-spacer>
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn
                      :disabled="!valid"
                      @click="submit"
                      color="primary"
                      large
                  >
                    {{ $vuetify.t('$vuetify.next') }}
                    <v-icon right small>fal fa-angle-double-right</v-icon>
                  </v-btn>
                </div>
              </v-flex>
              <v-spacer class="my-4"></v-spacer>
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn
                      @click="passwordRecover"
                      flat
                      small
                  >
                    {{ $vuetify.t('$vuetify.authentication.password_recover') }}
                  </v-btn>
                </div>
              </v-flex>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import {userService} from '../../_services'
import {getErrorMessage, recaptchaHelper} from "../../_helpers";
//TODO mover isto para block css
import "clientEntryLayout"

export default {
  data() {
    //Declaring the Data object for the Vue instance; later, after the instance has been mounted:
    //  some of these properties will be updated
    this.$log.debug("Username stored: " + this.$store.state.authentication.user.username);
    return {
      status: '',
      username: '',
      password: '',
      submitted: false,
      valid: false,
      e1: true,
      img_folder: "",
    }
  },
  computed: {
    // Defining the Password field as being mandatory;
    //  TODO: !!! Note: I don't know why I have to do this, once I have the field declared as REQUIRED
    passwordRules: function () {
      return [
        v => !!v || this.$vuetify.t('$vuetify.authentication.password_required'),
      ]
    }
  },
  methods: {
    submit() {
      // 1 - setting the Loading Layer
      this.$store.dispatch("loader/setLoading", true);

      // 2 - defining variables with both username and password values
      let password = this.password;
      let username = this.username;

      // 3 - Once both the username and the password are defined,
      //  it is possible to use the authentication module: the login action is called;
      //  this login action uses the userService's function login which uses the Axios library to fetch data in a async mode (using promises)
      //  to get the API token which will enable the user to be recognized by a match between the user and the received Token
      const {dispatch} = this.$store;
      if (username && password) {
        recaptchaHelper('login', this).then((token) => {
              dispatch('authentication/login', {username, password, token});
            },
            error => {
              getErrorMessage(error, 'Login User Recaptcha', this);
            });
      } else {
        getErrorMessage(false, 'User or Password not supplied!', this);
      }

    },
    passwordRecover() {
      // 1 - setting the Loading Layer
      this.$store.dispatch("loader/setLoading", true);

      this.$log.debug("Before Get New Password for User = " + this.username);

      let obj = {
        "username": this.username
      };

      recaptchaHelper('getNewPassword', this).then((token) => {
            obj.recaptcha_token = token;
            // eslint-disable-next-line
            userService.getNewPassword(obj).then(result => {
                  this.$log.debug("Get New Password | Received User Status = " + result.status);
                  this.$store.dispatch("loader/setLoading", false);
                  this.$store.dispatch("alert/success", this.$vuetify.t('$vuetify.authentication.password_new_success_sent'));
                },
                error => {
                  getErrorMessage(error, 'Get New Password', this);
                });
          },
          error => {
            getErrorMessage(error, 'Get New Password Recaptcha', this);
          });
    },
  },
  mounted() {
    this.img_folder = process.env.VUE_APP_ASSETS_FOLDER;
    // Called after the instance has been mounted:
    //  1 - getting the info whether it is a new user or not;
    //      this info is given by the router's "login-auth" parameter status
    this.status = this.$route.params.status;
    //  2 - getting from the store the username given on the 1st step (view LoginUsername);
    //      which was set on the authentication module by the setLoginUsername mutation
    this.username = this.$store.state.authentication.user.username;
    //  3 - if the user accessed this view directly, a information we can obtain by analyzing the username value,
    //      the user should be redirected to the 1st step (view LoginUsername);
    if (this.username === undefined || this.username === null) {
      this.$router.push({name: "login"});
    }
  }
}
</script>

<style lang="stylus">
/*.application*/
/*  background: #15191c url(../../assets/background.jpg) repeat-y 0 0 !important*/

/****************************************** START CACULA/DeGema *************************************************************/
/*#login-pwd-ui
    .v-responsive.v-image.my-5
        height: 300px !important;*/

/****************************************** END CACULA *************************************************************/

/****************************************** START NAZ *************************************************************/
/*#login-pwd-ui
    background: #EC0501 !important

    .login-logo
        margin-top: 10px !important;
        margin-bottom: 20px !important;

    .theme--dark.v-label
        color: #FFFFFF !important

    .theme--dark.v-input:not(.v-input--is-disabled) input
        color: #fff !important
        caret-color: #fff !important

    .error--text
        color: #fd0 !important
        caret-color: #fd0 !important

    .theme--dark.v-icon.error--text
        color: #fd0 !important

    .theme--dark.v-icon
        color: #FFFFFF !important

    .v-text-field > .v-input__control > .v-input__slot:after,
    .v-text-field > .v-input__control > .v-input__slot:after
        border-color: #fff !important

    .v-responsive.v-image.my-5
        height: 300px !important;

    .theme--dark.v-text-field > .v-input__control > .v-input__slot::before
        border-color: #fff !important

    .password-user-spacer,
    .password-title1-spacer,
    .password-title2-spacer
        display: none;

    .password-title1 h2
        font-size: 16px;

    // FONT SIZES CONFIG

    .v-btn
        font-size: 18px !important;

    .v-input,
    .v-label
        font-size 18px

    .password .v-input__control input
        font-family Helvetica-Light !important;*/

/******************************************** END NAZ *************************************************************/
</style>